/* eslint-disable camelcase */
// import axios from '../axios'

const DEFAULT_VALUATION = {
  ownership: [],
  created_at: null,
  timestamp: null
}

const DEFAULT_OWNERSHIP = {
  name: null,
  identity_no: '',
  mail_address: '',
  phone_no: '',
  address: '',
  share: 100
}

const ticket = {
  namespaced: true,
  state: {
    data: Object.assign({}, DEFAULT_VALUATION),
    ownership: Object.assign({}, DEFAULT_OWNERSHIP),
    editOwnershipIndex: null,
    step: 1,
    error: false,
    loading: false
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  actions: {
    // fetchList: async function (context) {
    //   context.commit('setLoading', { loading: true })
    //   try {
    //     const queryOption = {
    //       startkey: [{}],
    //       endkey: [],
    //       reduce: false,
    //       descending: true
    //     }
    //     const response = await axios.post('/api/query', { url: btoa(`/apply_trading/_design/search/_view/list`), payload: queryOption })
    //     const list = response.data.rows.map(row => row.value)
    //     context.commit('setList', { list })
    //     context.commit('setError', { error: null })
    //     return response
    //   } catch (error) {
    //     context.commit('setError', { error: { message: 'Data Not Found' } })
    //     throw error
    //   } finally {
    //     context.commit('setLoading', { loading: false })
    //   }
    // },
    resetData (context) {
      context.commit('setError', { error: null })
      context.commit('setLoading', { loading: null })
      context.commit('setList', { list: [] })
    }
  },
  mutations: {
    setError (state, payload) {
      state.error = payload.error
    },
    setList (state, payload) {
      state.list = payload.list
    },
    setLoading (state, payload) {
      state.loading = payload.loading
    },
    resetData (state) {
      state.data = Object.assign({}, DEFAULT_VALUATION)
      state.data.title = []
      state.data.ownership = []
    },

    resetOwnership (state) {
      state.ownership = Object.assign({}, DEFAULT_OWNERSHIP)
      state.editOwnershipIndex = null
    },

    setData (state, payload) {
      state.data = Object.assign({}, state.data, payload)
    },

    setOwnership (state, payload) {
      state.ownership = Object.assign({}, state.ownership, payload)
    },

    addOwnership (state) {
      const ownership = Object.assign({}, state.ownership)
      if (ownership.name) {
        ownership.name = ownership.name.trim().toUpperCase()
      }
      if (ownership.identity_no) {
        ownership.identity_no = ownership.identity_no
      }
      if (ownership.mail_address) {
        ownership.mail_address = ownership.mail_address
      }
      if (ownership.phone_no) {
        ownership.phone_no = ownership.phone_no
      }
      if (ownership.address) {
        ownership.address = ownership.address.trim().toUpperCase()
      }
      console.log(state.editOwnershipIndex)
      if (state.editOwnershipIndex === null) {
        state.data.ownership.push(ownership)
      } else {
        console.log(ownership)
        state.data.ownership[state.editOwnershipIndex] = ownership
        console.log(state.data.ownership[state.editOwnershipIndex])
      }
    },
    removeOwnership (state, index) {
      state.data.ownership.splice(index, 1)
    },

    setEditOwnershipIndex (state, editOwnershipIndex) {
      state.editOwnershipIndex = editOwnershipIndex
    },
    resetEditOwnershipIndex (state) {
      state.editOwnershipIndex = null
    }
  }
}

export default ticket
